// Redux Store Configuration
import { configureStore as createStore } from '@reduxjs/toolkit';
import rootReducer from './reducers';

// API Services - Legacy
import { userApi } from '../services/user';

// DDD Domains - New structure
import { authApi } from '../domains/auth/infrastructure/api/auth.api';
import { paymentApi } from '../domains/payment/infrastructure/api/payment.api';
import { roleApi } from '../domains/role/infrastructure/api/role.api';
import { orderApi } from '../domains/order/infrastructure/api/order.api';
import { subscriptionApi } from '../domains/subscription/infrastructure/api/subscription.api';
import { categoryApi } from '../domains/category/infrastructure/api/category.api';
import { notificationApi } from '../domains/notification/infrastructure/api/notification.api';
import { analyticsApi } from '../domains/analytics/infrastructure/api/analytics.api';
import { configurationApi } from '../domains/configuration/infrastructure/api/configuration.api';
import { reportApi } from '../domains/report/infrastructure/api/report.api';
import { mentorApi } from '../domains/mentor/infrastructure/api/mentor.api';
import { settingsApi } from '../domains/settings/infrastructure/api/settings.api';
import { userProfileApi } from '../domains/user/infrastructure/api/user.api';
import { unauthorizedMiddleware } from './unauthorizedMiddleware';

const configureStore = (initialState?: any) => {
  return createStore({
    reducer: rootReducer,
    preloadedState: initialState,
    middleware: getDefaultMiddleware =>
      getDefaultMiddleware({
        serializableCheck: false,
      }).concat(
        // Legacy
        userApi.middleware,
        // DDD Domains
        authApi.middleware,
        paymentApi.middleware,
        roleApi.middleware,
        orderApi.middleware,
        subscriptionApi.middleware,
        categoryApi.middleware,
        notificationApi.middleware,
        analyticsApi.middleware,
        configurationApi.middleware,
        reportApi.middleware,
        mentorApi.middleware,
        settingsApi.middleware,
        userProfileApi.middleware,
        unauthorizedMiddleware,
      ),
  });
};

export default configureStore;
